import { motion } from "framer-motion";
import { STATS, TESTIMONIALS } from "@/lib/site";
import { fadeUp } from "@/lib/anim";

export const Proof = () => {
  return (
    <section id="proof" data-testid="proof-section" className="border-b border-line">
      {/* Stats */}
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 border-b border-line">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              data-testid={`stat-${i}`}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true }}
              className={`py-12 md:py-16 px-5 md:px-8 ${i !== 0 ? "border-l border-line" : ""} ${i === 2 ? "border-t lg:border-t-0 border-line" : ""} ${i === 3 ? "border-t lg:border-t-0 border-line" : ""}`}
            >
              <div className="font-display font-black tracking-tighter text-5xl md:text-7xl text-acid leading-none">
                {s.value}
              </div>
              <p className="mt-3 font-mono text-[10px] md:text-[11px] uppercase tracking-[0.2em] text-white/50">
                {s.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>

      {/* Testimonials */}
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-20 md:py-28">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-acid mb-10">/ 03 — Proof</p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-line border border-line">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={i}
              data-testid={`testimonial-${i}`}
              variants={fadeUp}
              custom={i}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-60px" }}
              className="bg-ink-900 p-8 md:p-12"
            >
              <p className="font-display font-bold tracking-tight text-2xl md:text-3xl leading-[1.15]">
                “{t.quote}”
              </p>
              <footer className="mt-8 flex items-center gap-3">
                <span className="h-2 w-2 bg-acid rotate-45" />
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/60">
                  {t.name} — {t.role}
                </span>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};
